module.exports = "<ion-item>\r\n  A media is an item that can be added to a VR scene which learners can interact with.\r\n</ion-item>"